/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IAaaB2BOrderHistoryDetailData } from './aaa_b2b_order_history_detail.data';
import { IAaa_b2b_order_history_detailProps } from './aaa_b2b_order_history_detail.props.autogenerated';
import { getOrderHistoryAsync } from '../../dataActions/DataActionExtension.g';

export interface IAaa_b2b_order_history_detailViewProps extends IAaa_b2b_order_history_detailProps<IAaaB2BOrderHistoryDetailData> {
    requestOrderDetail: any;
    isLoading: boolean;
}

/**
 *
 * Aaa_b2b_order_detail component
 * @extends {React.PureComponent<IAaa_b2b_order_detailProps<IAaaB2BOrderDetailData>>}
 */
class Aaa_b2b_order_history_detail extends React.PureComponent<IAaa_b2b_order_history_detailProps<IAaaB2BOrderHistoryDetailData>, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            requestOrderDetail: {},
            toasterInfo: { visible: false },
            removePopUp: { visible: false },
            cart: undefined,
            isLoading: true
        };
    }

    public async componentDidMount(): Promise<void> {
        const params = new URLSearchParams(this.props.context.request.url.requestUrl.search);
        var salesId: string | null = '';
        var lineNum: string | null = '';
        if (params.has('salesId') && params.has('lineNum')) {
            // check url has recordId...
            salesId = params.get('salesId');
            lineNum = params.get('lineNum');
        }
        await this.getRequestOrder(salesId, lineNum);
    }

    public getRequestOrder = async (salesId: any, lineNum: any) => {
        const response: any = await getOrderHistoryAsync(
            { callerContext: this.props.context.actionContext, queryResultSettings: {} },
            0,
            0,
            { IncludeTotalCount: false, SalesId: salesId, LineNumber: Number(lineNum) }
        );
        if (response && response.Results.length > 0) {
            this.setState({ requestOrderDetail: response.Results[0], isLoading: false });
        }
    };
    public render(): JSX.Element | null {
        const viewProps: IAaa_b2b_order_history_detailViewProps = {
            ...(this.props as IAaa_b2b_order_history_detailProps<IAaaB2BOrderHistoryDetailData>),
            requestOrderDetail: this.state.requestOrderDetail,
            isLoading: this.state.isLoading
        };
        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default Aaa_b2b_order_history_detail;
